
import { mapGetters } from "vuex"

import seoTags from "@/mixins/seoTags"
import settings from "@/mixins/settings"
import metrika from "@/mixins/metrika"
import { otzovikList } from '../../utils/otzovikList';

export default {
  mixins: [metrika, seoTags],
  data() {
    return {
      isShowList: false,
      otzovikList,
    }
  },
  mounted() {
    setTimeout(function() {
      window.scrollTo(0, -100);
    }, 1);
  },
  computed: {
    settings() {
      return settings;
    },
    ...mapGetters({
      benefitsCredit: "benefits/benefitsCredit",
      benefitsCredit_slider: "benefits/benefitsCredit_slider",
      benefits_autoCredit: "benefits/benefits_autoCredit",
      settings: "settings/settings/settings"
    })
  },
  methods: {
    toggleList() {
      this.isShowList = !this.isShowList
    }
  }
};
